(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .controller('RenovarContratoAutomaticamenteCtrl', RenovarContratoAutomaticamenteCtrl);

  RenovarContratoAutomaticamenteCtrl.$inject = [
    '$uibModalInstance',
    'ContratoService',
    'MessagesService',
    'CONTACT_RENOVATION'
  ];
  // eslint-disable-next-line max-lines-per-function, max-params
  function RenovarContratoAutomaticamenteCtrl($uibModalInstance, ContratoService, MessagesService, CONTACT_RENOVATION) {
    const vm = this;
    vm.CONTACT_RENOVATION = CONTACT_RENOVATION;

    vm.loadingReject = false;
    vm.loadingApprove = false;
    vm.messageAlert = '';

    vm.sendRenovation = async function(approve) {
      if (approve) {
        vm.loadingApprove = true;
        // eslint-disable-next-line max-len
        vm.messageAlert = 'A solicitação de andamento de sua renovação de contrato foi enviada com sucesso para a equipe Comercial - Agro1';
      } else {
        // eslint-disable-next-line max-len
        vm.messageAlert = 'A solicitação de não andamento de sua renovação de contrato foi enviada com sucesso para a equipe Comercial - Agro1';
        vm.loadingReject = true;
      }

      vm.loading = true;
      await ContratoService.renovation({ approve }).then(() => {
        MessagesService.alert(vm.messageAlert);

        $uibModalInstance.close();
      })
        .catch((error) => {
          console.error(error);
          MessagesService.alert('Não foi possível enviar sua solicitação, tente novamente');
          $uibModalInstance.dismiss();
        })
        .finally(function() {
          vm.loadingReject = false;
          vm.loadingApprove = false;
        });
    };
  }
}());
